import { ReplaySubject, from, of } from 'rxjs';
import { AgGridService } from "../../../../shared/services/ag-grid/agGridService";
import { DataService } from "../../../../shared/services/dataService";
import DynamicControlService from '../../../../shared/services/dynamicControlService';
import { API_ENDPOINT, ENTITY_FIELD_TYPE } from "../../../../shared/types/enums";
import ApiService from "../../../../shared/services/apiService";
import LookupService from '../../../../shared/services/lookupService';
import ToastService from '../../../../shared/services/toastService';
import { MatIconService } from '../../../../shared/services/theme/matIconService';
import RolePermissionService from '../../../../shared/role-permissions/rolePermissionService';
import { TemplateFieldConfigUtil } from '../../../../shared/utilities/templateFieldConfigUtil';

export default class TransactionTabService {

    static proRataFieldId = 458;  // for splicing Currency after

    static otherFieldGroupKey = 100;
    static filterFieldGroupKey = 1;
    static staticFieldGroupKey = 2;
    static customFieldGroupKey = 9;

    static readonlyFieldIds = []; // filled in the INIT method

    static companyTransactionId = 23;
    static porzioGSTTransactionFieldId = 24;
    static transactionCategoryFieldId = 6;
    static transactionStatusFieldId = 33;
    static transactionConsentFieldId = 57;
    static transactionCompanySalesRepId = 460;

    // RecipinetInformation
    static recipientInformationFieldGroupKey = 3;
    // filled in the INIT method
    static recipientColCompanyProfileId = 47;
    static recipientColPorzioGstProfileId = 48;
    static recipientColLastNameFieldId = 50;
    static recipientColFirstNameFieldId = 51;
    static recipientColOrganizationName = 53;
    static recipientProfileTypeFieldId = 54;
    static recipientColCountryFieldId = 64;
    static recipientIdentifierTypeFieldId = 66;
    static recipientColRecipientIdentifierCountryFieldId = 501;
    static recipientColProfileStatusFieldId = -100; // TODO: not in template
    static recipientInformationFieldIds = [
        this.recipientColCompanyProfileId, this.recipientColPorzioGstProfileId,
        this.recipientColLastNameFieldId, this.recipientColFirstNameFieldId, this.recipientColOrganizationName, this.recipientProfileTypeFieldId, this.recipientColCountryFieldId,
        this.recipientIdentifierTypeFieldId, this.recipientColRecipientIdentifierCountryFieldId, this.recipientColProfileStatusFieldId,
    ];
    static recipinetProfileTypeLovOptions = [];
    static recipinetIdentifierTypeLovOptions = [];

    // OwnershipInformation
    static ownershipInformationFieldGroupKey = 4;
    static ownershipInformationFieldIds = []; // 

    // EngagementInformation Grid
    static engagementInformationFieldGroupKey = 5;
    static fieldEngagementCompanyEventFieldId = 68;
    static fieldEngagementNameFieldId = 70;
    static fieldEngagementTypeFieldId = 69;
    static fieldEngagementDescriptionFieldId = 331;
    static fieldEngagementStartDateFieldId = 71;
    static fieldEngagementEndDateFieldId = 72;
    static engagementInformationFieldIds = [
        this.fieldEngagementCompanyEventFieldId, this.fieldEngagementNameFieldId, this.fieldEngagementTypeFieldId,
        this.fieldEngagementDescriptionFieldId, this.fieldEngagementStartDateFieldId, this.fieldEngagementEndDateFieldId
    ];

    // VenueInformation Grid
    static venueInformationFieldGroupKey = 6;
    static fieldVenueNameFieldId = 73;
    static fieldVenueAddress1FieldId = 74;
    static fieldVenueAddress2FieldId = 75;
    static fieldVenueAddress3FieldId = 76;
    static fieldVenueAddress4FieldId = 77;
    static fieldVenueCityFieldId = 78;
    static fieldVenueProvinceFieldId = 79;
    static fieldVenuePostalCodeFieldId = 81;
    static fieldVenueCountryFieldId = 80;
    static venueInformationFieldIds = [
        this.fieldVenueNameFieldId, this.fieldVenueAddress1FieldId, this.fieldVenueAddress2FieldId, this.fieldVenueAddress3FieldId, this.fieldVenueAddress4FieldId,
        this.fieldVenueCityFieldId, this.fieldVenueProvinceFieldId, this.fieldVenuePostalCodeFieldId, this.fieldVenueCountryFieldId,
    ];


    // ResearchInformation
    static researchInformationFieldGroupKey = 7;
    static researchInformationFieldIds = []; //

    // PIInformation
    static PIInformationFieldGroupKey = 8;
    static principalInvestigatorID1 = 480;
    static principalInvestigatorID2 = 481;
    static principalInvestigatorID3 = 482;
    static principalInvestigatorID4 = 483;
    static principalInvestigatorID5 = 484;
    static PIInformationFieldIds = [
        this.principalInvestigatorID1, this.principalInvestigatorID2, this.principalInvestigatorID3, this.principalInvestigatorID4, this.principalInvestigatorID5
    ];

    // Currency Information (should go with Custom Fields)
    static userPersonalCurrencyFieldId = 1024;
    static convertedCurrencyTotalAmountFieldId = 1025;

    //--- GroupExpensesFields ------------
    static transactionTypeFieldId = 25;
    static transactionDateFieldId = 26;
    static initiatorLastNameFieldId = 27;
    static initiatorFirstNameFieldId = 28;
    static afiliatedCompanyFieldId = 29;
    static vendorNameFieldId = 30;

    static productFieldId = 31;
    static product2FieldId = 323;
    static product3FieldId = 324;
    static product4FieldId = 325;
    static product5FieldId = 326;

    static salesRepFieldId = 460;
    static formFieldId = 35;
    static purposeFieldId = 36;
    static totalAmountFieldId = 37;
    static totalNumberOfRecipientsFieldId = 38;
    static numberOfProfessionalRecipientsFieldId = 39;
    static numberOfNonProfessionalRecipientsFieldId = 40;
    static numberOfCompanyRepresentativesFieldId = 41;
    static numberOfNoShowsFieldId = 42;
    static baseCurrencyFieldId = 43;

    static engagementTypeFieldId = 69;
    static engagementNameFieldId = 70;
    static engagementStartDateFieldId = 71;
    static engagementEndDateFieldId = 72;

    static groupExpensesFieldIds = [
        this.transactionTypeFieldId, this.transactionDateFieldId, this.initiatorLastNameFieldId, this.initiatorFirstNameFieldId,
        this.afiliatedCompanyFieldId, this.vendorNameFieldId, this.productFieldId, this.product2FieldId, this.product3FieldId,
        this.product4FieldId, this.product5FieldId, this.salesRepFieldId, this.formFieldId,
        this.purposeFieldId, this.totalAmountFieldId, this.totalNumberOfRecipientsFieldId, this.numberOfProfessionalRecipientsFieldId,
        this.numberOfNonProfessionalRecipientsFieldId, this.numberOfCompanyRepresentativesFieldId, this.numberOfNoShowsFieldId,
        this.baseCurrencyFieldId, this.engagementTypeFieldId, this.engagementNameFieldId, this.engagementStartDateFieldId, this.engagementEndDateFieldId,
    ];


    static INIT = (_isClone) => {
        // readonly fields
        this.readonlyFieldIds = [...this.PIInformationFieldIds];
        this.recipinetProfileTypeLovOptions = [];
        if (!_isClone) {
            this.readonlyFieldIds.push(this.companyTransactionId); // requirement
        }
    }

    static hardCodeColumns = (_columnsArray) => {
        (_columnsArray || []).splice(0, 0, {
            "entityId": 1,
            "fieldAliasName": "PORZIOGSTTRANSACTIONID",
            "fieldId": TransactionTabService.porzioGSTTransactionFieldId,
            "isCustomField": false,
            "isExpViewDefault": false,
            "isPlsRequired": false,
            "startIndex": 1
        })

        return _columnsArray;
    }

    static hardcodeFields = (_compThisRef, isNew, _templateData) => {
        if (DataService.hasValue(_templateData)) {
            let index = 1000;
            const _templateKeys = Object.keys(_templateData) || [];

            //--- transaction status: --------------
            // delete duplicate key
            const duplicateTransactionStatusKey = DataService.getFirstOrDefault(_templateKeys.filter(x => x.toLowerCase().includes("transaction status")));
            if (duplicateTransactionStatusKey) { delete _templateData[duplicateTransactionStatusKey]; }
            // Make transactionStatus readonly and only be editable via Dialog
            _templateData.TransactionStatus = {
                // all others
                "isHidden": RolePermissionService.TRANSACTION_STATUS.cannotView,
                "isReadOnly": true,
                "fieldID": this.transactionStatusFieldId,
                "fielD_NAME": "Transaction Status",
                "fielD_DESCRIPTION": "Hardcoded filed",
                "fieldlength": 100,
                "field_Type_ID": 5,
                "entityName": "transactionstatusid",
                "fielD_ALIASNAME": "transactionstatusid",
                "iS_PLSREQUIRED": true,
                "isCustomField": false,
                "lookUpList": "",
                "toolTip": "Transaction Status",
                "mappedlovidfield": "transactionstatusid",
                "autoSelect": isNew, // autoselect for new
                "hideEmpty": true, // don't show none
                "customLOVList": DynamicControlService.transformToCustomLovList(
                    isNew ? [LookupService._TRANSACTION_STATUSES[0]] : LookupService._TRANSACTION_STATUSES, "id", "value", "transactionstatusid"),
                "customProfileLOVList": [],
                "customBoolean": false,
                "grouprenderid": 1,
                "endAdornmentActions": isNew ? [] : [ // this replaces the secondary action
                    {
                        icon: MatIconService.OVERRIDE_28, tooltip: "Override Transaction status", iconColor: "primary",
                        isReadOnly: RolePermissionService.TRANSACTION_STATUS.cannotEdit,
                        callback: () => { _compThisRef.setState({ showTransactionStatusDialog: true }) },
                    },
                ],
            }

            //--- Recipient Porzio GST Profile ID: --------------
            // delete duplicate key
            const duplicateRecipientPorzioGstProfileIdKey = DataService.getFirstOrDefault(_templateKeys.filter(x => x.toLowerCase().includes("porzio gst profile id")));
            if (duplicateRecipientPorzioGstProfileIdKey) { delete _templateData[duplicateRecipientPorzioGstProfileIdKey]; }
            // Make Recipient Porzio GST Profile ID readonly and only be editable via Dialog
            _templateData["Porzio GST Profile ID"] = {
                // all others
                "isHidden": false,
                "isReadOnly": true,
                "fieldID": this.recipientColPorzioGstProfileId,
                "fielD_NAME": "Porzio GST Profile ID",
                "fieldlength": 100,
                "field_Type_ID": 2,
                "entityName": "PORZIOGSTPROFILEID",
                "fielD_ALIASNAME": "PORZIOGSTPROFILEID",
                "fielD_DESCRIPTION": "Hardcoded filed",
                "fieldValueDetails": null,
                "iS_PLSREQUIRED": false,
                "isCustomField": false,
                "lookUpList": "",
                "toolTip": "Porzio GST Recipient ID",
                "mappedlovidfield": "porziogstprofileid",
                "autoSelect": isNew, // autoselect for new
                "hideEmpty": true, // don't show none
                "customProfileLOVList": [],
                "customBoolean": false,
                "grouprenderid": null,
                "ordinal": 1, // will be displayed first in the group
            }

            //--- As per PP2-407: --------------
            // find the key if exists else use manual name
            let porzioGstTransactionIdKey = DataService.getFirstOrDefault(_templateKeys.filter(x => x.toLowerCase().includes("porzio gst transaction id")));
            if (porzioGstTransactionIdKey) { delete _templateData[porzioGstTransactionIdKey]; }
            else { porzioGstTransactionIdKey = "Porzio GST Transaction ID"; }
            // build the key
            let porzioGstTransactionIdConfigValue = TemplateFieldConfigUtil.GET(TransactionTabService.filterFieldGroupKey, 2, ENTITY_FIELD_TYPE.TEXT, TransactionTabService.porzioGSTTransactionFieldId,
                "Porzio GST Transaction ID", "PORZIOGSTTRANSACTIONID", "PORZIOGSTTRANSACTIONID", "Porzio GST Transaction ID", "(Hardcoded field) A unique identifier assigned to each transaction, auto-generated by Porzio GST.")
                .isReadOnly(true).isVisible(!isNew).SET();
            // if required after a specific field, then find its index and pass the index here
            _templateData = DataService.addToObject(_templateData, porzioGstTransactionIdKey, porzioGstTransactionIdConfigValue, 1);



            //--- 1/3 CurrencyFields : ProRata --------------
            let proRataKey = DataService.getFirstOrDefault(_templateKeys.filter(x => x.toLowerCase().includes("pro rata")));
            if (proRataKey) { delete _templateData[proRataKey]; }
            // now add
            _templateData[`Pro Rata Amount`] = {
                "isReadOnly": false,
                "fieldID": this.proRataFieldId,
                "fielD_NAME": "Pro Rata Amount",
                "fielD_DESCRIPTION": "(Hardcoded field) Pro Rata amount for each recipient of the group expense. Recipients of a group expense will be determined by a common Event ID.",
                "fieldlength": 12,
                "field_Type_ID": 1,
                "fieldValueDetails": null,
                "entityName": "PRORATAAMT",
                "fielD_ALIASNAME": "PRORATAAMT",
                "iS_PLSREQUIRED": false,
                "isCustomField": false,
                "lookUpList": "",
                "toolTip": "Pro Rata Amount",
                "ordinal": 13,
                "mask": null,
                "hideEmpty": true, // don't show none
                "customfield": null,
                "encryption": null,
                "customLOVList": null,
                "customProfileLOVList": [],
                "customBoolean": false,
                "customDateTime": null,
                "grouprenderid": this.staticFieldGroupKey
            };

            //--- 2/3 CurrencyFields : UserPersonalCurrency --------------
            _templateData.UserPersonalCurrency = {
                "isReadOnly": true,
                "fieldID": this.userPersonalCurrencyFieldId,
                "fielD_NAME": "Converted Currency",
                "fielD_DESCRIPTION": "(Hardcoded field)",
                "fieldlength": 100,
                "field_Type_ID": 2,
                "entityName": "userpersonalcurrency",
                "fielD_ALIASNAME": "userpersonalcurrency",
                "iS_PLSREQUIRED": true,
                "isCustomField": false,
                "lookUpList": "",
                "toolTip": "Converted Currency",
                // "mappedlovidfield": "null",  If this has a value it will be the Control Name for Fomik; otherwise fielD_ALIASNAME
                "autoSelect": isNew, // autoselect for new
                "hideEmpty": true, // don't show none
                "customLOVList": null,
                "customProfileLOVList": [],
                "customBoolean": false,
                "grouprenderid": this.staticFieldGroupKey
            };

            //--- 2/3 CurrencyFields : ConvertedCurrencyTotalAmount --------------
            _templateData.ConvertedCurrencyTotalAmount = {
                "isReadOnly": true,
                "fieldID": this.convertedCurrencyTotalAmountFieldId,
                "fielD_NAME": "Converted Total Amount",
                "fielD_DESCRIPTION": "(Hardcoded field)",
                "fieldlength": 100,
                "field_Type_ID": 2,
                "entityName": "convertedcurrencytotalamount",
                "fielD_ALIASNAME": "convertedcurrencytotalamount",
                "iS_PLSREQUIRED": true,
                "isCustomField": false,
                "lookUpList": "",
                "toolTip": "Converted Total Amount",
                // "mappedlovidfield": "null",
                "autoSelect": isNew, // autoselect for new
                "hideEmpty": true, // don't show none
                "customLOVList": null,
                "customProfileLOVList": [],
                "customBoolean": false,
                "grouprenderid": this.staticFieldGroupKey
            };

        }
        return _templateData;
    }


    static getGroupFieldsMap = (_compThisRef, _isNew, _templateConfigData, _sortProp1, _sortProp2) => {

        // hardcode the Transaction-status dropdown, etc,...
        _templateConfigData = this.hardcodeFields(_compThisRef, _isNew, _templateConfigData);

        // cache lov's

        // reCreate map
        var groupInfoMap = new Map();
        groupInfoMap.set(this.filterFieldGroupKey, { "name": "", "fieldConfigs": [] });
        groupInfoMap.set(this.staticFieldGroupKey, { "name": "", "fieldConfigs": [] }); // static
        groupInfoMap.set(this.recipientInformationFieldGroupKey, { "name": "Recipient Information", "fieldConfigs": [] });
        groupInfoMap.set(this.ownershipInformationFieldGroupKey, { "name": "Ownership Information", "fieldConfigs": [] });
        groupInfoMap.set(this.engagementInformationFieldGroupKey, { "name": "Engagement Information", "fieldConfigs": [] });
        groupInfoMap.set(this.venueInformationFieldGroupKey, { "name": "Venue Information", "fieldConfigs": [] });
        groupInfoMap.set(this.researchInformationFieldGroupKey, { "name": "Research Information", "fieldConfigs": [] });
        groupInfoMap.set(this.PIInformationFieldGroupKey, { "name": "PI Information", "fieldConfigs": [] });
        groupInfoMap.set(this.customFieldGroupKey, { "name": "Custom Fields", "fieldConfigs": [] });
        groupInfoMap.set(this.otherFieldGroupKey, { "name": "Other Fields", "fieldConfigs": [] });


        // sort
        _templateConfigData = DataService.sortObjectByEntries(_templateConfigData, "ordinal");
        // extract keys
        const keys = Object.keys(_templateConfigData);
        if (DataService.hasNoElements(keys)) {
            groupInfoMap = new Map(); // clear the Map
        } else {
            let nonGroupedControls = [];
            // parse through each key
            keys.forEach(key => {
                // this applies the missing LOV's and corrcts incorrect configs
                const fieldConfig = DynamicControlService.transformFieldConfig(_templateConfigData[key]);
                if (!fieldConfig.isHidden) {
                    // cache lov's
                    if (fieldConfig.fieldID === this.recipientProfileTypeFieldId) {
                        this.recipinetProfileTypeLovOptions = fieldConfig.customLOVList.filter(x => x.lovId !== 0);
                    } else if (fieldConfig.fieldID === this.recipientIdentifierTypeFieldId) {
                        this.recipinetIdentifierTypeLovOptions = fieldConfig.customLOVList.filter(x => x.lovId !== 0);
                    }

                    // add any link properties if exists
                    this.setLinkPropertiesIfAny(_compThisRef, fieldConfig);
                    this.setAdornmentActionsIfAny(_compThisRef, fieldConfig);

                    var groupInfo = {};
                    if (fieldConfig.isCustomField) {
                        groupInfo = groupInfoMap.get(this.customFieldGroupKey);
                    } // CUSTOM
                    else if (this.recipientInformationFieldIds.includes(fieldConfig.fieldID)) { groupInfo = groupInfoMap.get(this.recipientInformationFieldGroupKey); } // recipientInformationGroup
                    else if (this.engagementInformationFieldIds.includes(fieldConfig.fieldID)) { groupInfo = groupInfoMap.get(this.engagementInformationFieldGroupKey); } // engagementGroup
                    else if (this.venueInformationFieldIds.includes(fieldConfig.fieldID)) { groupInfo = groupInfoMap.get(this.venueInformationFieldGroupKey); } // venueGroup
                    else if (groupInfoMap.has(fieldConfig.grouprenderid)) { groupInfo = groupInfoMap.get(fieldConfig.grouprenderid); }
                    else {
                        // TODO: Enable if others is needed
                        // nonGroupedControls.push(fieldConfig);
                        // groupInfo = groupInfoMap.get(this.otherFieldGroupKey);
                    } // add to unmatched

                    // push the field to the corresponding group
                    if (groupInfo.fieldConfigs) {
                        let _push = false;

                        // hide Porzio GST Profile if new
                        if (fieldConfig.fieldID === this.porzioGSTTransactionFieldId) {
                            _push = !_isNew; // can see only in edit
                        } else { _push = true; }

                        // readonly
                        if (this.readonlyFieldIds.includes(fieldConfig.fieldID)) {
                            fieldConfig.isReadOnly = true;
                        }

                        // add the field{
                        if (_push) { groupInfo.fieldConfigs.push(fieldConfig); }
                    }
                }
            });

            // show warnings
            if (DataService.hasElements(nonGroupedControls)) { console.warn("Controls with no GroupRendererId", nonGroupedControls); }
        }
        //sorting by ordinal
        groupInfoMap.forEach(value => {
            value.fieldConfigs = value.fieldConfigs.sort((a, b) => a.ordinal - b.ordinal);
        });


        //|---> rearranging order for Converted Currencies
        let staticGroupFields = groupInfoMap.get(this.staticFieldGroupKey).fieldConfigs;
        let indexToInsertAfter = staticGroupFields.findIndex(x => Number(x.fieldID) === Number(this.proRataFieldId));
        if (indexToInsertAfter < 0) indexToInsertAfter = staticGroupFields.length - 1;

        let indexUserPersonalCurrency = staticGroupFields.findIndex(x => x.fieldID === this.userPersonalCurrencyFieldId);
        let fieldConfigUserPersonalCurrency = staticGroupFields.splice(indexUserPersonalCurrency, 1);
        DataService.insertAt(staticGroupFields, indexToInsertAfter + 1, fieldConfigUserPersonalCurrency[0]);

        let indexConvertedCurrencyTotalAmount = staticGroupFields.findIndex(x => x.fieldID === this.convertedCurrencyTotalAmountFieldId);
        let fieldConfigConvertedCurrencyTotalAmount = staticGroupFields.splice(indexConvertedCurrencyTotalAmount, 1);
        DataService.insertAt(staticGroupFields, indexToInsertAfter + 2, fieldConfigConvertedCurrencyTotalAmount[0]);
        //<---|


        // return the Array of Arrays
        return groupInfoMap;
    }

    static setAdornmentActionsIfAny = (_compThisRef, _fieldConfig) => {
        // add secondary actions for PID's
        if (this.PIInformationFieldIds.includes(_fieldConfig.fieldID)) {
            _fieldConfig.endAdornmentActions = [
                { icon: MatIconService.SEARCH, iconColor: "primary", callback: _compThisRef.onPidSearchClick, tooltip: "Search Profile" },
                { icon: MatIconService.CLEAR_RED, iconColor: "default", callback: _compThisRef.onPidClearClick, tooltip: "Clear Profile" },
            ]
        }
    }

    static showProfileDetailDialog = (_compThisRef, _fieldConfig, _value, _profileId, _porziogstprofileid = "") => {
        if (_value && DataService.isValidNumber(_profileId) && DataService.hasValue(_profileId)) {
            // if (_compThisRef.props.isReadOnly) {
            //     ToastService.showWarning("Please switch to edit mode.");
            //     _fieldConfig.clickHandled = false; // reset so the linkClickCanWork
            //     this.state.targetPidFieldConfig.clickHandled = false; // reset so the linkClickCanWork
            // } else {
            _compThisRef.setState({
                targetPidFieldConfig: _fieldConfig,
                profileIdForDetailsDialog: _profileId,
                gstProfileIdForDetailsDialog: _porziogstprofileid,
                showProfileDetailDialog: true,
            });
            // }
        } else { ToastService.showError("Not a valid Profile"); }
         if (!DataService.hasValue(_profileId))
            {ToastService.showError("Readonly field");}
    }

    static setLinkPropertiesIfAny = (_compThisRef, _fieldConfig) => {

        switch (_fieldConfig.fieldID) {
            case TransactionTabService.recipientColPorzioGstProfileId:
                _fieldConfig[DynamicControlService.onClickCallbackKey] = (e) => {
                    TransactionTabService.showProfileDetailDialog(_compThisRef, _fieldConfig, e.value, _compThisRef.state.prid, _compThisRef.state.porziogstprofileid);
                }
                break;
            case TransactionTabService.principalInvestigatorID1:
                _fieldConfig[DynamicControlService.onClickCallbackKey] = (e) => {
                    if (!_fieldConfig.clickHandled) {
                        TransactionTabService.showProfileDetailDialog(_compThisRef, _fieldConfig, e.value, _compThisRef.state.initialValuesOrNull.pridpiid1);
                    }
                }
                break;
            case TransactionTabService.principalInvestigatorID2:
                _fieldConfig[DynamicControlService.onClickCallbackKey] = (e) => {
                    if (!_fieldConfig.clickHandled) {
                        TransactionTabService.showProfileDetailDialog(_compThisRef, _fieldConfig, e.value, _compThisRef.state.initialValuesOrNull.pridpiid2);
                    }
                }
                break;
            case TransactionTabService.principalInvestigatorID3:
                _fieldConfig[DynamicControlService.onClickCallbackKey] = (e) => {
                    if (!_fieldConfig.clickHandled) {
                        TransactionTabService.showProfileDetailDialog(_compThisRef, _fieldConfig, e.value, _compThisRef.state.initialValuesOrNull.pridpiid3);
                    }
                }
                break;
            case TransactionTabService.principalInvestigatorID4:
                _fieldConfig[DynamicControlService.onClickCallbackKey] = (e) => {
                    if (!_fieldConfig.clickHandled) {
                        TransactionTabService.showProfileDetailDialog(_compThisRef, _fieldConfig, e.value, _compThisRef.state.initialValuesOrNull.pridpiid4);
                    }
                }
                break;
            case TransactionTabService.principalInvestigatorID5:
                _fieldConfig[DynamicControlService.onClickCallbackKey] = (e) => {
                    if (!_fieldConfig.clickHandled) {
                        TransactionTabService.showProfileDetailDialog(_compThisRef, _fieldConfig, e.value, _compThisRef.state.initialValuesOrNull.pridpiid5);
                    }
                }
                break;
            case TransactionTabService.transactionCompanySalesRepId:
                _fieldConfig[DynamicControlService.onClickCallbackKey] = (e) => {
                    if (e.value) {
                        _compThisRef.setState({ salesRepIdForDetailsDialog: { companySalesRepId: _compThisRef.state.initialValuesOrNull.companysalesrepid, srid: undefined }, openSalesRepDialog: true });
                    } else { ToastService.showError("Not a valid SalesRep ID"); }
                }
                break;
            default: break;
        }

    }

    //#region Recipient Information 
    static getRecipientInformationRows = (_initialValuesOrNull) => {
        let oRET = [];
        if (DataService.hasValue(_initialValuesOrNull)) {
            oRET.push({
                "companyprofileid": _initialValuesOrNull["companyprofileId"],
                "porziogstprofileid": _initialValuesOrNull["porziogstprofileid"],
                "lastname": _initialValuesOrNull["lastname"],
                "firstname": _initialValuesOrNull["firstname"],
                "organizationname": _initialValuesOrNull["organizationname"],
                "country": _initialValuesOrNull["country"],
                "profilestatus": _initialValuesOrNull["profilestatus"],
            });
        }
        return oRET;
    }

    static getRecipientInformationObject = (_isactive = true) => {
        return {
            active: _isactive,
        };
    }

    static getUserCurrencyAsOBS = (_userId) => {
        return ApiService.getOBS(API_ENDPOINT.CORE, `/Transactions/GetUserCurrency?userId=${_userId}`);
    };

    static fetchCurrenciesAsOBS = (_userId) => {
        return ApiService.getOBS(API_ENDPOINT.CORE, `/Transactions/FetchCurrencies`);
    };

    static getConvertedTotalAmountAsOBS = (_tenantId, _sourceCurrency, _targetCurrency, _totalAmount, _transactionDate) => {
        //const _exchangeDate = new Date().toISOString().substring(0, 10)
        _totalAmount = _totalAmount === null ? 0 : _totalAmount;
        return ApiService.getOBS(API_ENDPOINT.CORE, `/Transactions/GetConvertedTotalAmount?tenantId=${_tenantId}&sourceCurrency=${_sourceCurrency}&targetCurrency=${_targetCurrency}&totalAmount=${_totalAmount}&exchangeDate=${_transactionDate}`);
    };

    /**
     * Refer url for more details: https://www.ag-grid.com/javascript-grid-column-properties/
     * @param _componentThisRef pass {this} keyword from the calling componenet
     * @param _recipientInformationFieldConfigs config Array
    */
    static getRecipientInformationColumnDefs = (_componentThisRef, _isReadOnly, _agGridUtils, _recipientInformationFieldConfigs) => {
        return [
            AgGridService.getTextColumn(false, "Porzio GST Profile ID", "porziogstprofileid"),
            AgGridService.getTextColumn(false, "Company Profile ID", "companyprofileid"),
            AgGridService.getTextColumn(false, "Last Name", "lastname"),
            AgGridService.getTextColumn(false, "First Name", "firstname"),
            AgGridService.getTextColumn(false, "Organization Name", "organizationname"),
            AgGridService.getTextColumn(false, "Country", "country"),
            AgGridService.getTextColumn(false, "Profile Status", "profilestatus"),
            AgGridService.getTextColumn(false, "Transaction Consent", "transactionconsent"),
        ];
    }

    //#endregion


    //#region Cleanup clone

    static cleanupClone = (_transactionToClone) => {
        if (_transactionToClone) {
            // clone
            let _cleanedClone = { ..._transactionToClone };

            // cleanup
            _cleanedClone.porziogsttransactionid = "";
            _cleanedClone.erroredFields = [];
            _cleanedClone["isrecipientmatch"] = false;

            // recipinet information
            _cleanedClone["porziogstprofileid"] = "";
            _cleanedClone["companyprofileid"] = "";
            _cleanedClone["companytransactionid"] = ""; // requirement
            _cleanedClone["profiletypeid"] = "";
            _cleanedClone["recipientcategoryid"] = "";
            _cleanedClone["organizationname"] = "";
            _cleanedClone["suffix"] = "";
            _cleanedClone["lastname"] = "";
            _cleanedClone["middlename"] = "";
            _cleanedClone["firstname"] = "";
            _cleanedClone["prefix"] = "";
            _cleanedClone["credentialsid"] = "";
            _cleanedClone["specialityid"] = "";
            _cleanedClone["address1"] = "";
            _cleanedClone["address2"] = "";
            _cleanedClone["address3"] = "";
            _cleanedClone["address4"] = "";
            _cleanedClone["city"] = "";
            _cleanedClone["province"] = "";
            _cleanedClone["country"] = "";
            _cleanedClone["postalcode"] = "";
            _cleanedClone["usnpinumber"] = "";
            _cleanedClone["uslicensestate"] = "";
            _cleanedClone["usstatelicensenumber"] = "";
            _cleanedClone["ustaxidnum"] = "";
            _cleanedClone["recipientidentifiercountry"] = "";
            _cleanedClone["recipientidentifiercountryid"] = "";
            _cleanedClone["recipientidentifiertypeid"] = "";
            _cleanedClone["recipientidentifiervalue"] = "";
            _cleanedClone["customermasterid"] = "";

            // return
            return _cleanedClone;
        } else {
            return null;
        }
    }
    //#endregion

    isGroupExpensesFieldsModified = () => {

    }


    static getKeyName = (_isEndsWithId, _isProductFields, _mappedFieldName) => {
        if (_isEndsWithId) { return _mappedFieldName.substring(0, _mappedFieldName.length - 2); } // <field> eg: transactionstatus
        else if (_isProductFields) {
            // productid2
            const lastChar = _mappedFieldName[_mappedFieldName.length - 1]; // lastChar
            return _mappedFieldName.substring(0, _mappedFieldName.length - 3) + lastChar;
        } else {
            return _mappedFieldName;
        }
    }

    static convertForPost = (_dataToPost, _fieldConfig, _mappedFieldName, _currentValue) => {
        let formattedValue = { 'value': null, 'isLOV': false, 'lovTextKey': '', 'lovTextValue': '' };

        if (DynamicControlService.booleanTransformFieldIds.includes(_fieldConfig.fieldID)) {
            _dataToPost[_mappedFieldName] = (_currentValue === true ? "Y" : "N");
            formattedValue['value'] = _dataToPost[_mappedFieldName];
        } else if (_fieldConfig.field_Type_ID === ENTITY_FIELD_TYPE.BOOLEAN) {//&& _oldValue !== _currentValue) {
            _dataToPost[_mappedFieldName] = DataService.parseBoolean(_currentValue);
            formattedValue['value'] = _dataToPost[_mappedFieldName];
        } else if ((_fieldConfig.field_Type_ID === ENTITY_FIELD_TYPE.NUMERIC || _fieldConfig.field_Type_ID === ENTITY_FIELD_TYPE.DECIMAL)) { // && _oldValue !== _currentValue) {
            _dataToPost[_mappedFieldName] = DataService.getNumberOrDefault(_currentValue, null);
            formattedValue['value'] = _dataToPost[_mappedFieldName];
        } else if (_fieldConfig.field_Type_ID === ENTITY_FIELD_TYPE.LOV) {
            formattedValue['isLOV'] = true;
            // For Lov both transactionstatusId & transactionstatus keys should be set
            _currentValue = _currentValue > 0 ? _currentValue : 0; // if null then use the 0 based lovKey
            // if (_oldValue !== _currentValue) {
            _dataToPost[_mappedFieldName] = _currentValue; // <field>Id eg: transactionstatusId
            formattedValue['value'] = _currentValue;
            // }

            const isEndsWithId = _mappedFieldName.endsWith("id");
            const isProductFields = ["productid2", "productid3", "productid4", "productid5"].includes(_mappedFieldName);
            if (isEndsWithId || isProductFields) {
                const _lovStringFieldName = TransactionTabService.getKeyName(isEndsWithId, isProductFields, _mappedFieldName);
                const lovObj = DataService.getFirstOrDefault(_fieldConfig.customLOVList.filter((x) => x.lovId === _currentValue));
                // if (_originalObj[_lovStringFieldName] !== lovObj?.lovKey) {
                _dataToPost[_lovStringFieldName] = lovObj ? lovObj.lovKey : "";
                formattedValue['lovTextKey'] = _lovStringFieldName;
                formattedValue['lovTextValue'] = _dataToPost[_lovStringFieldName].toLowerCase() === "-select-" ? "" : _dataToPost[_lovStringFieldName];
                // }
            }
            // creating a supplement key (countryid) for country which is required by id.
            if (_mappedFieldName === 'country') {
                const countryId = _dataToPost["country"];
                _dataToPost["countryid"] = countryId;
                _dataToPost["country"] = LookupService._COUNTRIES.find(c => c.id === countryId) ?
                    LookupService._COUNTRIES.find(c => c.id === countryId).value : "";
                // TODO: impl. formattedValue for country
            }
        } else {
            // if (_oldValue !== _currentValue) {
            _dataToPost[_mappedFieldName] = _currentValue;
            formattedValue['value'] = _currentValue;
            // }
        }

        // return
        return formattedValue;
    }

    //---
}